import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, {
  textFilter,
  dateFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { MdEdit, MdOutlineDelete, MdEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import paginationFactory from "react-bootstrap-table2-paginator";
import { toast } from "react-toastify";
import edMantra from "../../services/edMantra";
import _ from "lodash";
import loadinggif from "../../assets/images/loading.gif";
import { FaAddressCard } from "react-icons/fa";
import { useSelector } from "react-redux";
import { SiMicrosoftexcel } from "react-icons/si";
import { debounce } from "lodash";
import ToolkitProvider, {
  Search,
  CSVExport,
  pagination,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
const InterviewScheduling = (props) => {
  const { data } = useSelector((state) => state?.currentSession?.userInfo);
  const [showModal, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [allCandidate, setAllCandidate] = useState([]);
  const [allCompany, setAllCompany] = useState([]);
  const [openVacancy, setOpenVacancy] = useState([]);
  const [allInterview, setAllScheduledInterview] = useState([]);
  const [allRecruiters, setAllRecruiters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [companyName, setCompany] = useState(null);
  const [jobProfiles, setJobProfile] = useState([]);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(50);
  const [filters, setFilters] = useState({});
  const [totalScheduledInterviewCount, setTotalScheduledInterviewCount] =
    useState(0);
  const [itemObj, setItemObj] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ Add loading state
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const dropdownRef = useRef(null);
  const [interview, setInterView] = useState({
    companyId: "",
    interviewDate: "",
    candidateName: "",
    phone: "",
    companyName: "",
    jobProfile: "",
    candidateStatus: "",
  });

const handleShow = () => {
  // ⛔ Don't reset if editing
  if (isEdit) return;

  // ✅ Fresh form for new interview
  setInterView({
    interviewDate: "",
    candidateName: "",
    phone: "",
    companyName: "",
    companyId: "",
    jobProfile: "",
    candidateStatus: "",
  });

  setSearchTerm("");
  setAllCandidate([]);
  setAllCompany([]);
  setOpenVacancy([]);

  getAllCandidates();
  getAllCompany();
  setShow(true);
};


  const handleClose = () => {
    setShow(false);
    setIsEdit(false);
    setInterView({
      companyId: "",
      interviewDate: "",
      candidateName: "",
      phone: "",
      companyName: "",
      jobProfile: "",
      candidateStatus: "",
    });
  };

  const getAllRecruiters = async () => {
    try {
      const res = await edMantra.getAllRecruiters();

      if (res?.data?.errorCode === 0) {
        setAllRecruiters(res?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Custom CSS for blinking effect
  const styles = `
  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
  }
`;

  // Function to handle row selection
  const handleRowSelect = (row, isSelected) => {
    setSelectedRows([...selectedRows, row]);
  };
  console.log(selectedRows);

  // Function to handle row selection for all rows
  const handleRowSelectAll = (isSelected, rows) => {
    // Update selectedRows state when all rows are selected or deselected
    console.log(rows);
    if (isSelected) {
      setSelectedRows(rows);
    } else {
      setSelectedRows([]);
    }
  };
  const openwhatsApp = async (phone) => {
    try {
      if (!phone.startsWith("+91")) {
        phone = "+91" + phone;
      }
      const whatsappUrl = `https://wa.me/${phone}`;
      window.open(whatsappUrl, "_blank");
    } catch (error) {
      console.error(error);
    }
  };

  const openEamil = (email) => {
    const recipient = email;
    const subject = "Subject of the email";
    const body = "Content of the email";
    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  const formatDateforleadinout = (dateString) => {
    //for lead craetedAt and updatedAt
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Include this option for 12-hour format
    };
    return date.toLocaleDateString("en-GB", options);
  };

  // Filter candidates based on the search input
  const filteredCandidates = allCandidate.filter((item) =>
    `${item.firstName} ${item.lastName} (${item.candidateId})`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  // Handle candidate selection
const handleSelect = (item) => {
  const fullName = `${item.firstName} ${item.lastName} (${item.candidateId})`;
  handleOnchange(fullName, "candidateName");
  handleOnchange(item.phone, "phone");
  setSearchTerm(fullName);
  setIsOpen(false);
};


  const { ExportCSVButton } = CSVExport;
  const columns = [
    {
      dataField: "candidateName",
      text: "Candidate Name",
      sort: "true",
      filter: textFilter(),
    },

    {
      dataField: "phone",
      text: "Candidate Contact",
      sort: "true",
      filter: textFilter(),
    },

    {
      dataField: "email",
      text: "Email",
      filter: textFilter(),
    },

    {
      dataField: "companyName",
      text: "Company Name",
      sort: "true",
      filter: textFilter(),
    },

    {
      dataField: "jobProfile",
      text: "Job Profile",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "interviewDate",
      text: "Interview Date",
      sort: true,
      filter: dateFilter(),
     
    },
    {
      dataField: "candidateStatus",
      text: "Candidate Status",
      sort: "true",
      filter: textFilter(),
    },

    {
      dataField: "createdBy",
      text: "Recruitment Manager",

      filter: selectFilter({
        options: allRecruiters.map((emp) => ({
          value: emp.empId,
          label: `${emp.fname} ${emp.lname}`,
        })),
        placeholder: "Select or Search by Name",
      }),

      formatter: (cell, row) => {
        if (!allRecruiters.length) return "Loading...";

        const recruiter = allRecruiters.find(
          (emp) => emp.empId === row.createdBy
        );
        return recruiter
          ? `${recruiter.fname} ${recruiter.lname}`
          : "Not Assigned";
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="d-flex">
          <MdEdit
            size={25}
            color="black"
            style={{ cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(row)}
          />
          <MdOutlineDelete
            size={25}
            color="red"
            style={{ cursor: "pointer" }}
            onClick={() => handleDelete(row?.scheduleId)}
          />

          <div className="mx-2 pointer-cursor">
            <FaWhatsapp
              onClick={() => openwhatsApp(row?.mobile)}
              size={20}
              color="limegreen"
            />
          </div>
          <div className="ms-2 pointer-cursor">
            <MdEmail
              style={{ cursor: "pointer" }}
              onClick={() => openEamil(row.email)}
              size={20}
              color="#0072c6"
            />
          </div>
        </div>
      ),
    },
  ];

  const handleOnchange = (value, valueField) => {
    setInterView((prev) => ({
      ...prev,
      [valueField]: value,
    }));
  };

  const getAllCandidates = async (searchTerm = "") => {
    try {
      setLoading(true);
      console.log("🔍 Fetching candidates with:", searchTerm);

      const res = await edMantra.getAllCandidates(1, 20, {
        search: searchTerm,
      });

      if (res?.data?.errorCode === 0) {
        const candidateList = res.data.data?.rows || res.data.data || [];
        setAllCandidate(candidateList);
      } else {
        setAllCandidate([]);
        toast.error(res.data.message || "No candidates found");
      }
    } catch (error) {
      console.error("❌ Candidate fetch error:", error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchCandidates = useRef(
    debounce((value) => {
      getAllCandidates(value);
    }, 300)
  ).current;

  const searchCandidates = async (term) => {
    try {
      setLoading(true);
      const result = await edMantra.searchCandidatesByTerm(term); // Your new API
      if (result?.data?.errorCode === 0) {
        setAllCandidate(result?.data?.data);
      } else {
        setAllCandidate([]);
      }
    } catch (error) {
      console.error("Candidate search error:", error);
      setAllCandidate([]);
    } finally {
      setLoading(false);
    }
  };

  const getAllCompany = async () => {
    try {
      const result = await edMantra.getAllUniqueCompany({ empId: data?.empId });
      console.log("API Result: ", result?.data); // Log the response for debugging

      if (result?.data?.errorCode === 0) {
        setAllCompany(result?.data?.data); // Set company data if the API call is successful
      } else {
        console.error(result?.data?.message); // Log any errors
      }
    } catch (error) {
      console.error("Error fetching companies: ", error);
    }
  };

  const getOpenVacancy = async () => {
    try {
      const result = await edMantra.getOpenVacancy({
        companyId: interview?.companyId,
      });
      console.log(result, "Dekhte fahbdjvdvc ndvh cnsb"); // Log the response for debugging
      setOpenVacancy([]);
      if (result?.data?.errorCode === 0) {
        setOpenVacancy(result?.data?.data); // Set company data if the API call is successful
      } else {
        console.error(result?.data?.message); // Log any errors
      }
    } catch (error) {
      console.error("Error fetching companies: ", error);
    }
  };

  const getJobProfileByCompany = async () => {
    try {
      const result = await edMantra.getJobProfileByCompany({
        companyName,
        empId: data?.empId,
      });
      setJobProfile([]);

      if (result?.data?.errorCode === 0) {
        setJobProfile(result?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllScheduledInterview = async (page, sizePerPage, filters = {}) => {
    if (!data?.empId) return;

    try {
      const queryParams = new URLSearchParams({
        page,
        limit: sizePerPage,
        empId: data.empId,
        ...filters,
      });

      const response = await edMantra.getAllScheduledInterview(
        queryParams.toString()
      );

      console.log("📦 API response:", response?.data); // ✅

      if (response?.data?.errorCode === 0) {
        console.log("✅ Data received:", response.data.data); // ✅
        setAllScheduledInterview(response.data.data);
        setTotalScheduledInterviewCount(response.data.totalRecords);
      } else {
        console.warn("⚠️ No data or error:", response?.data?.message);
        setTotalScheduledInterviewCount([]);
      }
    } catch (error) {
      console.error("❌ Error fetching vacancies:", error);
      setTotalScheduledInterviewCount([]);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, filters: rawFilters }
  ) => {
    const parsedFilters = {};

    if (rawFilters.candidateName) {
      parsedFilters.candidateName = rawFilters.candidateName.filterVal;
    }
    if (rawFilters.phone) {
      parsedFilters.phone = rawFilters.phone.filterVal;
    }
    if (rawFilters.email) {
      parsedFilters.email = rawFilters.email.filterVal;
    }
    if (rawFilters.companyName) {
      parsedFilters.companyName = rawFilters.companyName.filterVal;
    }
    if (rawFilters.jobProfile) {
      parsedFilters.jobProfile = rawFilters.jobProfile.filterVal;
    }

    if (rawFilters.candidateStatus) {
      parsedFilters.candidateStatus = rawFilters.candidateStatus.filterVal;
    }

    if (rawFilters.interviewDate?.filterVal?.date) {
  const dateOnly = new Date(rawFilters.interviewDate.filterVal.date)
    .toISOString()
    .split("T")[0]; // ✅ convert to 'YYYY-MM-DD'

  parsedFilters["interviewDate[date]"] = dateOnly;
  parsedFilters["interviewDate[comparator]"] =
    rawFilters.interviewDate.filterVal.comparator || "=";
}



    if (rawFilters.createdBy) {
      parsedFilters.createdBy = rawFilters.createdBy.filterVal;
    }

    setFilters(parsedFilters);

    await setTotalScheduledInterviewCount(page, sizePerPage, parsedFilters);
  };

  const pagination = paginationFactory({
    page,
    sizePerPage,
    totalSize: totalScheduledInterviewCount,
    showTotal: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "500", value: 500 },
      { text: "1000", value: 1000 },
    ],
    onPageChange: setPage,
    onSizePerPageChange: (newSize, newPage) => {
      setSizePerPage(newSize);
      setPage(newPage);
    },
  });

  const handleUpdateInterview = async () => {
    try {
      const res = await edMantra.updateInterviewScheduleById(interview);
      if (res?.data?.errorCode === 0) {
        toast.success(res?.data?.message);
        getAllCandidates();
        getAllCompany();
        getAllScheduledInterview();
        setShow(false);
        setInterView({
          interviewDate: "",
          candidateName: "",
          companyName: "",
          jobProfile: "",
          candidateStatus: "",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

const handleSubmit = async () => {
  try {
    const result = await edMantra.addInterviewScheduling({
      ...interview,
      createdBy: data?.empId,
    });

    if (result?.data?.errorCode === 0) {
      toast.success(result?.data?.message || "Interview scheduled");

      // ✅ Refresh interview list
      await getAllScheduledInterview(1, 50, {}); // or pass current page/filters

      // ✅ Reset form and close modal
      setShow(false);
      setInterView({
        interviewDate: "",
        candidateName: "",
        phone: "",
        companyName: "",
        companyId: "",
        jobProfile: "",
        candidateStatus: "",
      });
      setSearchTerm("");
      setAllCandidate([]);
      setAllCompany([]);
      setOpenVacancy([]);
    } else {
      toast.error(result?.data?.message || "Something went wrong");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Internal server error");
    console.error("❌ Submit error:", error);
  }
};


const handleEdit = (row) => {
  setInterView(row);
  setIsEdit(true);
  setShow(true); // ✅ no reloads triggered
};


  const handleDelete = async (scheduleId) => {
    try {
      const res = await edMantra.deleteInterviewById({ scheduleId });
      if (res.data?.errorCode === 0) {
        toast.success(res?.data?.message);
        getAllCandidates();
        getAllCompany();
        getAllScheduledInterview();
      }
    } catch (error) {
      console.error(error);
    }
  };
  // 🔁 Load once on mount: candidates, recruiters, and job profiles
  useEffect(() => {
    getAllCandidates();
    getAllRecruiters();

    const fetchJobProfiles = async () => {
      try {
        const result = await edMantra.getAllUniqueCompany({
          empId: data?.empId,
        });
        const json = await result.json();
        setJobProfile(json);
      } catch (error) {
        console.error("Error fetching job profiles:", error);
      }
    };

    fetchJobProfiles();
  }, []);

  // 🔁 Load interview list once empId is available or pagination/filter changes
  useEffect(() => {
    if (data?.empId) {
      getAllScheduledInterview(page, sizePerPage, filters);
    }
  }, [data?.empId, page, sizePerPage, JSON.stringify(filters)]);

  // 🔁 Load company list only when reload flag changes (e.g. after submission)
  useEffect(() => {
    if (reload) {
      getAllCompany();
      setReload(false); // ✅ reset reload flag to avoid infinite loop
    }
  }, [reload]);

  // 🔁 When a company is selected, fetch job profiles under it
  useEffect(() => {
    if (companyName) {
      getJobProfileByCompany();
    }
  }, [companyName]);

  // 🔁 When a company is selected for interview scheduling, load open vacancies
  useEffect(() => {
    if (interview.companyId) {
      getOpenVacancy();
    }
  }, [interview.companyId]);

  // 🔁 Click outside dropdown handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 card border-0">
            <p className="fs-3 fw-normal typed-text">Schedule Interview</p>
          </div>

          <div className="card col-md-3 col-sm-12 border-0">
            <button
              type="button"
              className="btn btn-warning btn-sm"
              onClick={() => handleShow()}
            >
              <FaAddressCard color={"black"} size={20} /> Add Interview
            </button>
          </div>

          <div className="card col-md-12 border-0">
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <img src={loadinggif} alt="Loading" />
              </div>
            ) : (
              <ToolkitProvider
                keyField="companyId"
                data={allInterview}
                columns={columns}
                exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                search
              >
                {(props) => (
                  <div>
                    {(data?.role?.roleName === "SuperAdmin" ||
                      data?.role?.roleName === "AdminEM") && (
                      <ExportCSVButton
                        className="btn btn-success btn-sm mb-2 float-end"
                        {...(props.csvProps || {})}
                        filename="MantrasERP_Record.csv"
                      >
                        <SiMicrosoftexcel />
                        Export Record
                      </ExportCSVButton>
                    )}
                    <div className="table-responsive cus-table">
                      <style>{styles}</style>{" "}
                      {/* Inject the blinking effect CSS */}
                      <BootstrapTable
                        keyField="interviewId"
                        data={allInterview}
                        columns={columns}
                        bootstrap4
                        striped
                        hover
                        condensed
                        filter={filterFactory()}
                        filterPosition="top"
                        remote={{ filter: true, pagination: true }}
                        pagination={pagination}
                        onTableChange={handleTableChange}
                      />
                    </div>
                  </div>
                )}
              </ToolkitProvider>
            )}
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <u>Schedule Interview Form</u>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <h6 className="custom-h6">Schedule Interview and Placement</h6>
          <div className="row">
            <div className="col-md-12">
              <p className="mb-0 fs-6"> Interview Date</p>
              <input
                placeholder="Date of Creation"
                className="form-control py-0 "
                type="date"
                value={interview.interviewDate}
                onChange={(e) =>
                  handleOnchange(e.target.value, "interviewDate")
                }
              />
            </div>
            <div className="col-md-12">
              <p className="mb-0 fs-6">Candidate Name</p>
              <div ref={dropdownRef} className="position-relative w-100">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Candidate..."
                  value={searchTerm}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchTerm(value);

                    if (value.length >= 3) {
                      debouncedFetchCandidates(value);
                      setIsOpen(true);
                    } else {
                      setAllCandidate([]);
                      setIsOpen(false);
                    }
                  }}
                  onFocus={() => {
                    setIsOpen(true);

                    // If candidates not yet loaded, load initial list
                    if (allCandidate.length === 0 && !searchTerm) {
                      getAllCandidates(); // no search term = fetch recent
                    } else if (searchTerm.length >= 3) {
                      debouncedFetchCandidates(searchTerm);
                    }
                  }}
                />

                {isOpen && (
                  <ul
                    className="list-group position-absolute w-100 bg-white shadow-sm border rounded"
                    style={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 10,
                    }}
                  >
                    {loading ? (
                      <li className="list-group-item text-muted">Loading...</li>
                    ) : allCandidate.length > 0 ? (
                      allCandidate.map((item, index) => (
                        <li
                          key={index}
                          className="list-group-item list-group-item-action"
                         onClick={() => handleSelect(item)}
                          style={{ cursor: "pointer" }}
                        >
                          {/* 👇 Display with fallback */}
                          {item.phone || item.mobile || "📞N/A"} —{" "}
                          {item.firstName && item.lastName
                            ? `${item.firstName} ${item.lastName}`
                            : item.fullName || "Unnamed"}
                        </li>
                      ))
                    ) : (
                      <li className="list-group-item text-muted">
                        No results found
                      </li>
                    )}
                  </ul>
                )}
              </div>

              <p className="mb-0 fs-6">Company Name</p>
              <select
                name=""
                id=""
                className="form-select"
                value={interview.companyId}
                onChange={(e) => {
                  const val = e.target.value;
                  const itemObj = allCompany.find(
                    (item) => item.companyId === val
                  );
                  handleOnchange(e.target.value, "companyId");
                  handleOnchange(itemObj.companyName, "companyName");
                }}
              >
                <option value="">Select Company</option>
                {allCompany.length > 0 &&
                  allCompany.map((item) => (
                    <>
                      <option value={item?.companyId} key={item?.companyId}>
                        {item?.companyName}
                      </option>
                    </>
                  ))}
              </select>
              {_.isNil(interview?.companyId) ||
              _.isEmpty(interview?.companyId) ? null : (
                <>
                  <p className="mb-0 fs-6">Job Profile</p>
                  <select
                    name=""
                    id=""
                    className="form-select"
                    value={interview.jobProfile}
                    onChange={(e) =>
                      handleOnchange(e.target.value, "jobProfile")
                    }
                  >
                    <option value="">Select Job Profile</option>
                    {openVacancy.length > 0 &&
                      openVacancy.map((item) => (
                        <option value={item?.jobProfile} key={item?.jobProfile}>
                          {item?.jobProfile}
                        </option>
                      ))}
                  </select>
                </>
              )}
            </div>
            <div className="col-md-12">
              <p className="mb-0 fs-6">Candidate Status</p>

              <select
                name=""
                id=""
                className="form-select"
                value={interview.candidateStatus}
                onChange={(e) =>
                  handleOnchange(e.target.value, "candidateStatus")
                }
              >
                <option value="">Select Status</option>
                <option value="CV Submitted">CV Submitted</option>
                <option value="Shortlisted">Shortlisted</option>
                <option value="Interviewed">Interviewed</option>
                <option value="Selected">Selected</option>
                <option value="Hold">Hold</option>
                <option value="Rejected">Rejected</option>
                <option value="Joined">Joined</option>
                <option value="Terminated">Terminated</option>
                <option value="Working">Working</option>
                <option value="Registered">Registered</option>
                <option value="Not Joined">Not Joined</option>
              </select>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} size="sm">
            Close
          </Button>
          {isEdit ? (
            <Button variant="primary" onClick={handleUpdateInterview} size="sm">
              Update Interview
            </Button>
          ) : (
            <Button variant="primary" onClick={handleSubmit} size="sm">
              Schedule Interview
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InterviewScheduling;
